<div class="mt-3">
    <app-common-import 
    [steps]="steps"
    [data]="data"
    (checkValidation)="checkedValidation($event)"
    (lastButtonClicked)="lastButtonClicked($event)"
    ></app-common-import>
</div>
